import React from "react";
import Picture from "../../../components/common/Picture";

interface ImageOverlayCardProps {
    imageSrc: string;
    altText: string;
    title: string;
    style?: React.CSSProperties;
    className?: string;
}

export const ImageOverlayCard: React.FC<ImageOverlayCardProps> = ({imageSrc, altText, title, style, className}) => {
    return (
        <div className={`h-full ${className}`} style={style}>
            <div className="rounded-lg overflow-hidden h-full w-full shadow-2xl relative">
                <Picture
                    {...(imageSrc.toLowerCase().endsWith('.webp') ? { webpSrc: imageSrc } : imageSrc.toLowerCase().endsWith('.png') ? { pngSrc: imageSrc } : { jpgSrc: imageSrc })}
                    alt={altText}
                    className="w-full h-full object-cover"
                    onErrorSrc={`https://placehold.co/800x600/153D40/C6A375?text=${altText}`}
                />
                <div
                    className="absolute bottom-0 left-0 right-0 bg-royal-pine text-ivory flex justify-between items-center">
                    <div className="px-2 py-2 sm:px-4 sm:py-4 lg:px-6 lg:py-4">
                        <h3 className="heading-font text-md sm:text-lg md:text-xl lg:text-2xl">
                            {title}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
};
